import { render, staticRenderFns } from "./DaysMgmt.vue?vue&type=template&id=6cc822e8&scoped=true&"
import script from "./DaysMgmt.vue?vue&type=script&lang=js&"
export * from "./DaysMgmt.vue?vue&type=script&lang=js&"
import style0 from "./DaysMgmt.vue?vue&type=style&index=0&id=6cc822e8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cc822e8",
  null
  
)

export default component.exports